import { HomeIcon, UserIcon, ShoppingBagIcon } from './Icons'

const colors = {
  bg: '#050508',
  cardBg: '#141418',
  nestedBg: '#1c1c22',
  accent: '#9333ea',
  accentLight: '#a855f7',
  cardBorder: 'rgba(255, 255, 255, 0.12)',
  text: '#ffffff',
  textMuted: 'rgba(255, 255, 255, 0.52)',
}

interface BottomNavProps {
  activeTab?: string
  onNavigate?: (tab: 'home' | 'orders' | 'profile') => void
}

export default function BottomNav({ activeTab = 'home', onNavigate }: BottomNavProps) {
  const tabs = [
    { id: 'home', label: 'Главная', icon: HomeIcon },
    { id: 'orders', label: 'Заказы', icon: ShoppingBagIcon },
    { id: 'profile', label: 'Профиль', icon: UserIcon },
  ]

  const handleTabClick = (tabId: string) => {
    if (onNavigate) {
      onNavigate(tabId as 'home' | 'orders' | 'profile')
    }
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: colors.cardBg,
      borderTop: `1px solid ${colors.cardBorder}`,
      padding: '8px 12px calc(8px + env(safe-area-inset-bottom))',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 50,
    }}>
      {tabs.map(tab => {
        const isActive = activeTab === tab.id
        const Icon = tab.icon
        
        return (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              background: isActive ? colors.nestedBg : 'transparent',
              border: 'none',
              borderRadius: '10px',
              padding: '8px 12px',
              cursor: 'pointer',
              minWidth: '60px',
              transition: 'all 0.2s',
            }}
          >
            <Icon 
              size={22} 
              color={isActive ? colors.accent : colors.textMuted}
              strokeWidth={isActive ? 2.2 : 1.8}
            />
            <span style={{
              color: isActive ? colors.accent : colors.textMuted,
              fontSize: '10px',
              fontWeight: isActive ? 600 : 400,
            }}>
              {tab.label}
            </span>
          </button>
        )
      })}
    </div>
  )
}
